"use client";

import Image from "next/image";
import { useId, useState } from "react";
import "./collapsible-row.scss";
import CaretDownIcon from "./images/caretdown.svg";
import CaretUpIcon from "./images/caretup.svg";

interface Props {
  collapsedTitle: string;
  expandedTitle: string;
  columnCount: number;
  children: React.ReactNode;
}

export default function CollapsibleRow({
  collapsedTitle,
  expandedTitle,
  columnCount,
  children,
}: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const contentId = useId();

  return (
    <>
      <tr className={`moreInfoRowToggle ${isOpen ? "isOpen" : ""}`}>
        <td colSpan={columnCount}>
          <button
            className="moreInfoToggle"
            aria-label={isOpen ? expandedTitle : collapsedTitle}
            aria-expanded={isOpen}
            aria-controls={contentId}
            onClick={() => setIsOpen(!isOpen)}
            type="button"
          >
            <div className="sectionTitle">
              <div className="imageWrapper">
                <Image
                  src={isOpen ? CaretUpIcon : CaretDownIcon}
                  alt=""
                  width={16}
                  height={16}
                />
              </div>
              <span>{isOpen ? expandedTitle : collapsedTitle}</span>
            </div>
          </button>
        </td>
      </tr>

      {isOpen && (
        <tr className="moreInfoRowContent">
          <td colSpan={columnCount}>
            <div id={contentId} role="region" aria-label={expandedTitle}>
              {children}
            </div>
          </td>
        </tr>
      )}
    </>
  );
}
